<template>
  <div
    v-if="buttonContainerLinks"
    class="btn-container"
    :class="{
      'is-horizontal': buttonContainerPositionHorizontal,
      ['is-aligned-to-' + buttonContainerAlignment]: true,
    }"
  >
    <span
      v-for="(link, index) in buttonContainerLinks"
      :key="index"
      :class="!link.href && 'hidden'"
    >
      <kf-link
        :type="link.type"
        :href="setHref(link)"
        :target="link.target"
        @handleClick="setAnalyticsData(link)"
      >
        {{ link.label }}
      </kf-link>
    </span>
  </div>
</template>

<script>
import KfLink from '@/components/base/link/Link.vue';
import { gtmTemplates, trackEvent } from '@/lib/gtm/trackEvent';

export default {
  name: 'KfButtonContainer',
  components: {
    KfLink,
  },
  props: {
    schoolData: {
      type: Object,
      default: null
    },
    buttonContainerPositionHorizontal: {
      type: Boolean,
      default: false,
    },
    buttonContainerAlignment: {
      type: String,
      default: 'left'
    },
    buttonContainerLinks: {
      type: Array,
      default: null,
    },
  },
  methods: {
    setAnalyticsData(e) {
      const gtmData = e.trackData ? {
        ...gtmTemplates[e.trackData.template],
        ...e.trackData.data,
        event_label: e.label,
      } : {
          'event': 'vestigingspagina.click',
          'category': e.gaCategory,
          'action': 'button-click',
          'label': e.gaLabel,
        };
      trackEvent( gtmData , this.$gtm.enabled());
      trackEvent( {...e.secondTrackData}, this.$gtm.enabled());
    },
    setHref(item) {
      return item.trackData?.data?.location ? `${item.href}?zipcode=${item.trackData.data.location}` : item.href ? item.href : ''
    }
  },
};
</script>

<style lang="postcss">
.btn-container {
  @apply flex flex-col flex-wrap justify-center gap-6;

  &.is-aligned-to-left {
    @apply items-start;
  }

  &.is-aligned-to-center {
    @apply items-center;
  }

  &.is-aligned-to-right {
    @apply items-end;
  }

  &.is-horizontal {
    @apply flex-row items-center;

    &.is-aligned-to-left {
      @apply justify-start;
    }

    &.is-aligned-to-center {
      @apply justify-center;
    }

    &.is-aligned-to-right {
      @apply justify-end;
    }
  }
}
</style>
